import { render, staticRenderFns } from "./dataFrom.vue?vue&type=template&id=01c3506c&scoped=true&"
import script from "./dataFrom.vue?vue&type=script&lang=js&"
export * from "./dataFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c3506c",
  null
  
)

export default component.exports